import { Settings } from '@/shared/types/Settings';

import { BASE_URL } from '../constants';
import { get } from '../requestMethods';

const URL = `${BASE_URL}/api/config`;
export const APP_SETTINGS_API = {
  // Get app settings
  getAppSettings: () => get<Settings>(`${URL}/settings`),
};
